function Departures(props) {
    return <div class="card">
        <div class="card-body">
            <h5 class="card-title"><i class="fa-solid fa-bus me-2"></i>Straßenbahnzeiten Mühlenpfordstraße</h5>
        </div>
        <ul class="list-group list-group-flush">
            {props.data.map((departure) => <DepartureListItem departure={departure} />)}
        </ul>
    </div>
}

function DepartureListItem(props) {
    return <li className="list-group-item">
        <div className="row">
            <div className="col-1">
                <p className="h5">
                    {props.departure.line}
                </p>
            </div>
            <div className="col">
                <p className="h5 m-0">{props.departure.destination}</p>
                <p className="mb-1">{props.departure.track}</p>
            </div>
            <DepartureTimeBlock scheduledTime={props.departure.scheduledTime} actualTime={props.departure.actualTime}/>
        </div>
    </li>
}

function DepartureTimeBlock(props) {
    const timeToMs = (timeStr) => {
        const [hours, minutes] = timeStr.split(":");
        return (parseInt(hours) * 60 * 60 + parseInt(minutes) * 60) * 1000;
    };
    
    const getColorClass = (delay) => {
        if (delay <= 2) return 'text-success';
        if (delay <= 7) return 'text-warning';
        return 'text-danger';
    };
    
    const delayInMinutes = (timeToMs(props.actualTime) - timeToMs(props.scheduledTime)) /1000 / 60;

  return <div className="col-auto">
        <p className={`h5 m-0 ${getColorClass(delayInMinutes)}`}>{props.actualTime}</p>
        <p className="mb-1 text-end">{props.scheduledTime}</p>
    </div>
}

export default Departures;